import { render, staticRenderFns } from "./SearchSpecialRequests.vue?vue&type=template&id=2007c8c8&scoped=true"
import script from "./SearchSpecialRequests.vue?vue&type=script&lang=js"
export * from "./SearchSpecialRequests.vue?vue&type=script&lang=js"
import style0 from "./SearchSpecialRequests.vue?vue&type=style&index=0&id=2007c8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007c8c8",
  null
  
)

export default component.exports